<div class="row p-3">
    <div class="col-12 text-center">
        <button class="btn btn-rounded btn-info btn-sm download-btn pd-tool-style-btn w-100" type="button" (click)="close(1)">
            Download Product Mockup <i class="fas fa-download"></i>
        </button>            
    </div>
    <div class="col-12 text-center mt-2">
        <button class="btn btn-rounded btn-info btn-sm download-btn pd-tool-style-btn w-100" type="button" (click)="close(2)">
            Download Art Mockup <i class="fas fa-download"></i>
        </button>
    </div>
</div>